<template>
  <jz-container id="dashboard-container">
    <update-ios-app-notification v-if="withUpdateNotification" />
    <call-to-action v-if="withNotificationCTA" />
    <terratalk-live-session-active
      v-for="sessionDetails in sessions"
      :key="sessionDetails.id"
      :session-details="sessionDetails"
    />

    <jz-spinner v-if="isLoading" />

    <recent-exercises-list class="dashboard-section no-margin-section" />
    <assignments-card class="dashboard-section" />
    <bookmarked-courses-list class="dashboard-section no-margin-section" />
    <recommended-courses-list class="dashboard-section no-margin-section" />
  </jz-container>
</template>

<script>
import AssignmentsCard from "@tt-app/components/dashboard/AssignmentsCard";
import CallToAction from "@tt-app/components/notifications/CallToAction";
import UpdateIosAppNotification from "@tt-app/components/ui/UpdateIosAppNotification";
import RecentExercisesList from "@tt-app/components/dashboard/RecentExercisesList";
import BookmarkedCoursesList from "@tt-app/components/dashboard/BookmarkedCoursesList.vue";
import RecommendedCoursesList from "@tt-app/components/dashboard/RecommendedCoursesList.vue";
import { NotificationPermission } from "@tt-app/store/user/types";
import TerratalkLiveSessionActive from "@tt-app/components/notifications/TerratalkLiveSessionActive";
import {
  TerratalkLiveGetterNames,
  TerratalkLiveNamespace
} from "@tt-app/store/terratalkLive/types";

export default {
  name: "Dashboard",
  components: {
    TerratalkLiveSessionActive,
    AssignmentsCard,
    CallToAction,
    UpdateIosAppNotification,
    RecentExercisesList,
    BookmarkedCoursesList,
    RecommendedCoursesList
  },
  data: function() {
    return {
      loadingBookmarked: true
    };
  },
  computed: {
    terratalkLiveSessionActive() {
      const session = this.$store.getters[
        `${TerratalkLiveNamespace}/${TerratalkLiveGetterNames.ACTIVE_SESSION}`
      ];

      return Boolean(session);
    },

    sessions() {
      const sessionDetailsById = this.$store.getters[
        `${TerratalkLiveNamespace}/${TerratalkLiveGetterNames.SESSION_DETAILS}`
      ];

      return Object.values(sessionDetailsById || {});
    },

    withNotificationCTA() {
      const {
        oneSignal: { notificationPermission, ctaInteraction }
      } = this.$store.state;

      if (ctaInteraction === undefined || notificationPermission === undefined) {
        return false;
      }

      const noInteractionYet = !this.$store.state.oneSignal.ctaInteraction;
      const permissionDefault = notificationPermission === NotificationPermission.DEFAULT;
      const permissionDenied = notificationPermission === NotificationPermission.DENIED;
      const subscribed = ctaInteraction === NotificationPermission.GRANTED;

      return noInteractionYet || ((permissionDefault || permissionDenied) && subscribed);
    },

    withUpdateNotification() {
      const rawAudioRecorderAvailable = typeof window.RawAudioRecorder !== "undefined";
      const nativePlaybackUnavailable = typeof window.Native?.playback === "undefined";

      return rawAudioRecorderAvailable && nativePlaybackUnavailable;
    },

    isLoading() {
      const { learningHistory, assignment, content } = this.$store.state;
      const { bookmark, recommended } = content;
      return learningHistory.loading ||
        assignment.loading ||
        bookmark.loading ||
        recommended.loading
        ? true
        : false;
    }
  }
};
</script>

<style lang="scss">
div#dashboard-container {
  --tt-dashboard-grid-gap: #{$gutter / 2};
  padding: $gutter $gutter/2;
  overflow: auto;

  .dashboard-section {
    margin-bottom: $gutter * 2;
  }
  .section-header {
    color: var(--color-dark);
    font-size: $font-size-xxl;
    font-weight: bold;
  }
  .no-margin-section .container {
    margin-left: -$gutter/2;
    margin-right: -$gutter/2;
  }
  .no-margin-section .container .container-item:first-child {
    margin-left: $gutter/2;
  }
}

@include responsive(tablet) {
  div#dashboard-container {
    height: auto;
    padding: $gutter/2 $gutter * 1.75;
    padding-top: $gutter * 1.75;

    .no-margin-section .container {
      margin-right: -($gutter * 1.75);
      margin-left: -($gutter * 1.75);
    }

    .no-margin-section .container .container-item:first-child {
      margin-left: $gutter * 1.75;
    }
  }
}
</style>
